var PurchasePixel = (function (window) {
	var PurchasePixel = function (opts) { };

	_.extend(PurchasePixel.prototype, {
		confirmation: function (conf, summaryModel) {
			if (!conf || !summaryModel || !Pixel || !Pixel.events) {
				return;
			}

			var order = conf.get('order'),
				orderInfoResult = conf.get('orderInfoResult');

			if (!orderInfoResult || !order) {
				return;
			}

			Pixel.events.trigger('purchaseSuccess ', _.extend({
				OrderInfoResult: orderInfoResult,
				paymentID: conf.get('paymentID'),
				orderNo: conf.get('invoiceNo'),
				currencyIso: window.GlobalSettings.Currency,
			}, this._getAdditionalData(order, summaryModel)));
		},

		_getAdditionalData: function (model, summaryModel) {
			var itemsList = model.get('ItemList'),
				data = {
					pricesArr: itemsList.pluck('Price'),
					productIDsArr: itemsList.map(function (m) { return kos.guidToBase64(m.get('ID')); }),
					qtyArr: itemsList.pluck('Qty'),
					discounts: itemsList.pluck('Discount'),
				};

			return _.extend(data, {
				prices: data.pricesArr.join(','),
				productIDs: data.productIDsArr.join(','),
				totalQty: itemsList.reduce(function (result, m) { return m.get('Qty') + result; }, 0),
				totalValue: summaryModel.get('Total'),
				revenue: summaryModel.get('Subtotal')
			});
		}
	});

	return PurchasePixel;
})(window);